/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
import { fireScreenAnalytics, fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { sendPendoTrackEvent } from './sendPendoTrackEvent.tsx';

export const BoardView = {
	opened: (
		event: UIAnalyticsEvent,
		accessLevel?: string,
		attributes?: Record<string, unknown>,
	): void => {
		// https://app.pendo.io/s/4758009750487040/trackevents/qM00ZERYuH-iFTxMnCfYLZpuKgQ
		sendPendoTrackEvent({
			actionSubjectAndAction: 'boardView opened',
			attributes: { accessLevel: accessLevel || '' },
		});

		// https://data-portal.internal.atlassian.com/analytics/registry/51089
		fireScreenAnalytics(event, { accessLevel, ...attributes });
	},
	cardDropped: (event: UIAnalyticsEvent, attributes: Record<string, unknown> = {}): void => {
		sendPendoTrackEvent('boardViewCard dropped');

		// https://data-portal.internal.atlassian.com/analytics/registry/50694
		fireUIAnalytics(event, 'card dragged', 'idea', attributes);
	},
	columnDropped: (event: UIAnalyticsEvent, attributes: Record<string, unknown>): void => {
		sendPendoTrackEvent('boardViewColumn dropped');
		// https://data-portal.internal.atlassian.com/analytics/registry/50789
		fireUIAnalytics(event, 'column dragged', 'fieldValue', attributes);
	},
	fieldValueUpdatedByDragBetweenColumns: (fieldType: string | undefined): void => {
		sendPendoTrackEvent(`fieldValue updated ${fieldType} boardDragBetweenColumns`);
	},
	fieldValueUpdatedByDragBetweenSwimlanes: (fieldType: string | undefined): void => {
		sendPendoTrackEvent(`fieldValue updated ${fieldType} boardDragBetweenSwimlanes`);
	},
	searchOrCreateClicked: (event: UIAnalyticsEvent): void => {
		// https://data-portal.internal.atlassian.com/analytics/registry/75136
		fireUIAnalytics(event, 'button clicked', 'boardColumnSearchOrCreate', {});
	},
	searchOrCreateNewIdeaClicked: (event: UIAnalyticsEvent): void => {
		// https://data-portal.internal.atlassian.com/analytics/registry/75135
		fireUIAnalytics(event, 'button clicked', 'boardColumnSearchOrCreateNewIdea', {});
	},
};
